import * as types from './types'

export const mutations = {
	[types.CLEAR_ARTICLES] (state) {
		state.articles = []
		state.banques = []
		state.myNews = []
	},
	[types.CLEAR_TAGS] (state) {
		state.tags = []
		state.userTags = []
	},
	[types.ADD_ARTICLE] (state, data) {
		let t = new Date(data.created_at)
		if (t instanceof Date && !isNaN(t.getTime())) {
			data.created_at = new Date(data.created_at)
		} else {
			const d = data.created_at.substring(0, 10).split('/').reverse().concat(data.created_at.substring(10).split(':'))
			data.created_at = new Date(d[0], d[1], d[2], d[3], d[4]).toISOString()
		}
		let index = 0
		state.articles.forEach((article, key) => {
			if (data.created_at < article.created_at) {
				index = key + 1
			}
		})
		state.articles.splice(index, 0, data)
	},
	[types.ADD_BANQUE] (state, data) {
		state.banques.push(data)
	},
	[types.ADD_GENERAL_TAG] (state, data) {
		state.tags.push(data)
	},
	[types.ADD_USER_TAG] (state, data) {
		state.userTags.push(data)
	},
	[types.ADD_MY_NEWS] (state, data) {
		let t = new Date(data.created_at)
		if (t instanceof Date && !isNaN(t.getTime())) {
			data.created_at = new Date(data.created_at)
		} else {
			const d = data.created_at.substring(0, 10).split('/').reverse().concat(data.created_at.substring(10).split(':'))
			data.created_at = new Date(d[0], d[1], d[2], d[3], d[4]).toISOString()
		}
		let index = 0
		state.articles.forEach((article, key) => {
			if (data.created_at < article.created_at) {
				index = key + 1
			}
		})
		state.myNews.splice(index, 0, data)
	}
}



// WEBPACK FOOTER //
// ./src/common/store/News/mutations.js